import React from 'react';
import PropTypes from 'prop-types';

import { camelize } from 'inflected';
import displayName from 'component-lib/displayName';
import styles from './Checkboxes.scss';

export default function generateCheckboxContainer(type) {
    function container({ children }) {
        return (<span className={styles[`checkbox-${type}`]}>
            {children}
        </span>)
    }

    container.propTypes = {
        children: PropTypes.node.isRequired,
    };

    container.displayName = displayName(`Forms/Checkboxes/${camelize(type)}CheckboxContainer`);

    return container;
}
